import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import useIsVisible from '@jimmyboys/liita-ui/dist/hooks/useIsVisible'
import React, { useRef, useEffect } from 'react'
import styles from './LazyLoader.module.sass'

const LazyLoader = (props) => {
	const { className, onVisible, isLoading, hasMore, ...attributes } = props
	const { i18n } = useGlobal()
	const element = useRef(null)
	const isVisible = useIsVisible(
		element,
		undefined,
		`${window.innerHeight * 0.25}px`
	)
	useEffect(() => {
		let timeout
		if (isVisible && !isLoading && hasMore) {
			timeout = setTimeout(() => {
				onVisible && onVisible()
			}, 150)
		}
		return () => {
			clearTimeout(timeout)
		}
	}, [isVisible, isLoading, onVisible, hasMore])
	return (
		<div
			{...attributes}
			ref={element}
			className={`${styles['root'] || ''} ${className || ''}`}
		>
			{isLoading ? (
				<small>{i18n`Loading`}</small>
			) : hasMore ? (
				<small>{i18n`Load more`}</small>
			) : null}
		</div>
	)
}

export default LazyLoader
